export default __webpack_public_path__ + "static/media/linkedin.f4041044.svg";